import { Select, TextInput, ComboboxData } from "@mantine/core";
import { documentTypeDisplayValueMap } from "../../types/document";

import styles from "./choose-document-type-modal-view.module.scss";
import { AppealSupportingDocumentType } from "@/__generated__/graphql.ts";
import { Button } from "@/components/buttons/Button";

const documentTypeOptions: ComboboxData = Object.entries(
  documentTypeDisplayValueMap,
)
  .map(([key, value]) => ({ value: key, label: value }))
  .filter(
    ({ value }) =>
      value !== AppealSupportingDocumentType.CoverLetter &&
      value !== AppealSupportingDocumentType.InsuranceForm &&
      value !== AppealSupportingDocumentType.PatientConsent,
  );

const emojiRegex =
  /([\u2700-\u27BF]|[\uE000-\uF8FF]|[\uD83C-\uDBFF\uDC00-\uDFFF]|[\u2011-\u26FF]|\uFE0F)/gu;

type ChooseDocumentTypeModalViewProps = {
  selectedDocumentType: AppealSupportingDocumentType | null;
  setSelectedDocumentType: (documentType: AppealSupportingDocumentType) => void;
  otherDocumentName: string;
  setOtherDocumentName: (documentName: string) => void;
  onContinue: () => void;
};

export const ChooseDocumentTypeModalView = ({
  selectedDocumentType,
  setSelectedDocumentType,
  otherDocumentName,
  setOtherDocumentName,
  onContinue,
}: ChooseDocumentTypeModalViewProps) => (
  <>
    <h2 className={styles.modalContentHeader}>
      {"Tell us about your document"}
    </h2>
    <p className={styles.modalContentDescription}>
      {"Let us know what type of document you are uploading"}
    </p>
    <div className={styles.documentTypeSelects}>
      <Select
        label="What document are you uploading?"
        data={documentTypeOptions}
        placeholder="Select a document type"
        withCheckIcon={false}
        value={selectedDocumentType}
        onChange={(value) =>
          value &&
          setSelectedDocumentType(value as AppealSupportingDocumentType)
        }
        classNames={{
          label: styles.documentTypeLabel,
          input: styles.documentTypeInput,
          option: styles.documentTypeOption,
        }}
      />
      {selectedDocumentType === AppealSupportingDocumentType.Other && (
        <TextInput
          label="What should we call your document?"
          placeholder="Enter document name"
          classNames={{
            label: styles.documentTypeLabel,
            input: styles.documentTypeInput,
          }}
          value={otherDocumentName}
          onChange={(event) => {
            const valueWithoutForbiddenCharacters =
              event.currentTarget.value.replace(emojiRegex, "");

            setOtherDocumentName(valueWithoutForbiddenCharacters);
          }}
        />
      )}
    </div>
    <Button
      onClick={onContinue}
      type="button"
      variant="primary"
      size="medium"
      disabled={
        !selectedDocumentType ||
        (selectedDocumentType === AppealSupportingDocumentType.Other &&
          !otherDocumentName)
      }
      isFullWidth
    >
      {"Next"}
    </Button>
  </>
);
